export default {
  install: (app, options) => {
    app.config.globalProperties.$gotoMain = $gotoMain;
    app.config.globalProperties.$gotoShop = $gotoShop;
    app.config.globalProperties.$gotoMarketplace = $gotoMarketplace;
    app.config.globalProperties.$gotoCart = $gotoCart;
    app.config.globalProperties.$gotoSupplierContact = $gotoSupplierContact;
    app.config.globalProperties.$gotoShopBySupplierRefId = $gotoShopBySupplierRefId;
    app.config.globalProperties.$gotoCommonError = $gotoCommonError;
    app.config.globalProperties.$gotoIntro = $gotoIntro;
    app.config.globalProperties.$gotoInfoAboutNavigatingToNewSupplier = $gotoInfoAboutNavigatingToNewSupplier;
    app.config.globalProperties.$gotoAccountRegistry = $gotoAccountRegistry;
    app.config.globalProperties.$gotoLogin = $gotoLogin;
    app.config.globalProperties.$gotoLoginWithPhone = $gotoLoginWithPhone;
    app.config.globalProperties.$gotoProfile = $gotoProfile;
    app.config.globalProperties.$gotoPromoProducts = $gotoPromoProducts;
    app.config.globalProperties.$gotoDealProducts = $gotoDealProducts;
    app.config.globalProperties.$gotoPasswordResetCodeEmailRequest = $gotoPasswordResetCodeEmailRequest;
    app.config.globalProperties.$gotoPasswordResetCodePhoneRequest = $gotoPasswordResetCodePhoneRequest;
    app.config.globalProperties.$gotoResetPasswordWithEmail = $gotoResetPasswordWithEmail;
    app.config.globalProperties.$gotoResetPasswordWithPhone = $gotoResetPasswordWithPhone;
    app.config.globalProperties.$gotoResetPassword = $gotoResetPassword;
    app.provide('PageRouter', options);
  }
}

export function $gotoIntro(ins) {  
  if(ins){
    console.log("Redirecting to landing page.");
  }
  window.location.href="/page/landing.html";
}

export function $gotoMain(ins) {  
  ins.$router.push({
    path: "/",
  });
}

export function $gotoMarketplace(ins) {  
  ins.$router.push({
    path: "/marketplace",
  });
}

export function $gotoPromoProducts(ins) {  
  ins.$router.push({
    path: "/promo-products",
  });
}
export function $gotoDealProducts(ins) {  
  ins.$router.push({
    path: "/deal-products",
  });
}

export function $gotoShop(ins) {
  /*
  let supplierRefId = ins.$retrieveSupplierRefId();
  if (supplierRefId) {
    ins.$router.push({
      path: "/store/" + supplierRefId,
    });
  } else {
    ins.$router.push({
      path: "/",
    });
  }*/
  
  ins.$router.push({
    path: '/products'
  });
}

export function $gotoCart(ins) {
  let supplierRefId = ins.$retrieveSupplierRefId();
  if (supplierRefId) {
    ins.$router.push({
      path: "/cart",
    });
  } else {
    ins.$router.push({
      path: "/",
    });
  }
}

export function $gotoSupplierContact(ins) {

  let supplierRefId = ins.$retrieveSupplierRefId();
  if (supplierRefId) {
    ins.$router.push({
      path: "/contact/" + supplierRefId,
    });
  } else {
    ins.$router.push({
      path: "/",
    });
  }

}

export function $gotoInfoAboutNavigatingToNewSupplier(ins,fromSupplierRefId,toSupplierRefId) {
  if (fromSupplierRefId&&toSupplierRefId) {
    ins.$router.push({
      path: "/change-store/" + fromSupplierRefId + "/" + toSupplierRefId,
    });
  } else {
    ins.$router.push({
      path: "/",
    });
  }

}


export function $gotoShopBySupplierRefId(supplierRefId) {
  /*
  if (supplierRefId) {
    this.$router.push({
      path: "/store/" + supplierRefId,
    });
  } else {
    this.$router.push({
      path: "/",
    });
  }
  */

  let defaultSupplierRefId=process.env.VUE_APP_SUPPLIER_REF_ID;
  if(defaultSupplierRefId){
    this.$router.push({
      path: '/products'
    });
  }else{
    if (supplierRefId) {
      this.$router.push({
        path: "/store/" + defaultSupplierRefId,
      });
    } else {
      this.$router.push({
        path: "/",
      });
    }
  }
  
}

export function $gotoLogin(ins) {
  ins.$router.push({ path: '/login' });
}

export function $gotoLoginWithPhone(ins) {
  ins.$router.push({ path: '/login-with-phone' });
}

export function $gotoAccountRegistry(ins) {
  ins.$router.push({ path: '/account-registry' });
}

export function $gotoPasswordResetCodeEmailRequest(ins) {
  ins.$router.push({ path: '/request-reset-password-with-email' });
}

export function $gotoPasswordResetCodePhoneRequest(ins) {
  ins.$router.push({ path: '/request-reset-password-with-phone' });
}

export function $gotoResetPasswordWithEmail(ins) {
  ins.$router.push({ path: '/reset-password-with-email' });
}

export function $gotoResetPasswordWithPhone(ins) {
  ins.$router.push({ path: '/reset-password-with-phone' });
}

export function $gotoResetPassword(ins) {
  ins.$router.push({ path: '/reset-password' });
}

export function $gotoProfile(ins) {
  ins.$router.push({ path: '/profile' });
}

export function $gotoCommonError(ins) {
  ins.$router.push({ path: '/error' });
}